import React, { Component } from 'react'
import PropTypes from "prop-types"
import classNames from 'classnames'
import NextBoxHeader from "./NextBoxHeader"
import ListBoxItems from "./ListBoxItems"
import BoxItemStatistics from "./BoxItemStatistics"
import CloseBox from "./CloseBox"
import ReopenBox from "./ReopenBox"


class NextBoxDetail extends Component {
    state = {
        showDelete : false
    }

    handleCheckDelete = (value) => {
        this.setState({
            showDelete: value
        })
    }

    render() {
        const { box, items, onClose, onRefresh, isPrivate, indexBoxClosed, onUpdateLocalStore, barcodeError, loading, isAdmin } = this.props
        const { status } = box
        const {showDelete} = this.state

        return (
            <div className={classNames("NextBoxDetail", status)}>
                <div className="card">
                    <NextBoxHeader
                        box={box}
                        indexBoxClosed={indexBoxClosed}
                        items={items}
                        onUpdateLocalStore={onUpdateLocalStore}
                        onRefresh={onRefresh}
                        barcodeError={barcodeError}
                        onClose={onClose}
                    />
                    <BoxItemStatistics items={items} />
                    <ListBoxItems 
                        onRefresh={onRefresh} 
                        isPrivate={isPrivate} 
                        items={items} box={box} 
                        loading={loading} 
                        isAdmin={isAdmin} 
                        showDelete={showDelete}
                        handleCheckDelete={this.handleCheckDelete}
                    />
                    <CloseBox barcodeError={barcodeError} onClose={onClose} box={box} position='footer' />
                    <ReopenBox onRefresh={onRefresh} isPrivate={isPrivate} box={box} />
                </div>
            </div>
        )
    }
}

NextBoxDetail.propTypes = {
    box: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    onRefresh: PropTypes.func.isRequired,
    isPrivate: PropTypes.bool.isRequired,
}

export default NextBoxDetail
